export default __webpack_public_path__ + "static/media/OilPump.256.2d41997d.png";